import { render, staticRenderFns } from "./pbook.vue?vue&type=template&id=1ec2a4b8&scoped=true&"
import script from "./pbook.vue?vue&type=script&lang=js&"
export * from "./pbook.vue?vue&type=script&lang=js&"
import style0 from "./pbook.vue?vue&type=style&index=0&id=1ec2a4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2a4b8",
  null
  
)

export default component.exports